import { ROUTE_TYPES } from '@feedback/router';

export const homeRedirect = {
  type: ROUTE_TYPES.REDIRECT,
  from: '/',
  to: '/home',
  exact: true,
};
